module.exports = __webpack_public_path__ + "static/media/pull_back_hair.3094b768.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/pull_back_hair.svg
// module id = 166
// module chunks = 0